// Constants and helpers for Events Admin
import { Car, Train, Plane, Bus, Navigation, Users, Mic2, Building2, Star } from 'lucide-react';
import { toast } from 'sonner';

export const directionIconOptions = [
  { value: 'car', label: 'Auto', icon: Car },
  { value: 'train', label: 'Treno', icon: Train },
  { value: 'plane', label: 'Aereo', icon: Plane },
  { value: 'bus', label: 'Bus', icon: Bus },
  { value: 'default', label: 'Altro', icon: Navigation },
];

export const statIconOptions = [
  { value: 'users', label: 'Partecipanti', icon: Users },
  { value: 'speakers', label: 'Speaker', icon: Mic2 },
  { value: 'companies', label: 'Aziende', icon: Building2 },
  { value: 'default', label: 'Altro', icon: Star },
];

export const defaultSponsorTiers = [
  { name: "Main Partner", weight: 1 },
  { name: "In collaborazione con", weight: 2 },
  { name: "Con il patrocinio di", weight: 3 },
  { name: "Partner", weight: 4 },
  { name: "Special Partner", weight: 5 },
  { name: "Smart Partner", weight: 6 },
  { name: "Grazie a", weight: 7 }
];

export const initialFormData = {
  title: '',
  edition_id: '',
  location: '',
  city: '',
  address: '',
  venue_name: '',
  description: '',
  date: '',
  end_date: '',
  event_start_time: '',
  event_end_time: '',
  hero_image: '',
  hero_image_mobile: '',
  hero_video: '',
  header_banner_enabled: false,
  header_banner_text: '',
  header_banner_image: '',
  slug: '',
  status: 'draft',
  stats: [],
  ticket_url: '',
  ticket_price: '',
  ticket_label: '',
  sponsors: [],
  sponsor_groups: [],
  testimonials: [],
  topics: [],
  google_maps_embed: '',
  directions: [],
  content_sections: [],
  content_section_title: '',
  content_blocks: [],
  seo_keywords: [],
  rss_feed_url: '',
  rss_feed_title: '',
};

export const initialSessionFormData = {
  title: '',
  track_id: '',
  speaker_ids: [],
  description: '',
  start_time: '',
  end_time: '',
};

export const generateSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
};

export const applyMarkdownFormat = (textareaId, formatType, currentText, onTextChange) => {
  const textarea = document.getElementById(textareaId);
  if (!textarea) return;
  
  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;
  const selectedText = currentText.substring(start, end);
  
  if (start === end) {
    toast.info('Seleziona del testo per applicare la formattazione');
    return;
  }
  
  let formattedText = '';
  let prefix = '';
  let suffix = '';
  
  switch (formatType) {
    case 'bold':
      prefix = '**';
      suffix = '**';
      break;
    case 'italic':
      prefix = '*';
      suffix = '*';
      break;
    case 'heading':
      prefix = '## ';
      suffix = '';
      break;
    default:
      return;
  }
  
  if (selectedText.startsWith(prefix) && selectedText.endsWith(suffix) && suffix !== '') {
    formattedText = selectedText.slice(prefix.length, -suffix.length);
  } else if (suffix === '' && selectedText.startsWith(prefix)) {
    formattedText = selectedText.slice(prefix.length);
  } else {
    formattedText = prefix + selectedText + suffix;
  }
  
  const newText = currentText.substring(0, start) + formattedText + currentText.substring(end);
  onTextChange(newText);
  
  setTimeout(() => {
    textarea.focus();
    const newEnd = start + formattedText.length;
    textarea.setSelectionRange(start, newEnd);
  }, 0);
};
